module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 20\"><polygon fill=\"#7A8291\" points=\"41 10.012 41 12 43.312 12 40.387 20 38 20 38 21.988 45 21.988 45 20 42.953 20 45.878 12 48 12 48 10.012\" transform=\"translate(-33 -6)\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/italic.svg
// module id = 757
// module chunks = 0